var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 22.0039H15.9998C20.0198 22.0039 20.7398 20.3939 20.9498 18.4339L21.6998 10.4339C21.9698 7.99391 21.2698 6.00391 16.9998 6.00391H6.99983C2.72983 6.00391 2.02983 7.99391 2.29983 10.4339L3.04983 18.4339C3.25983 20.3939 3.97983 22.0039 7.99983 22.0039Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.00391V5.20391C8 3.43391 8 2.00391 11.2 2.00391H12.8C16 2.00391 16 3.43391 16 5.20391V6.00391",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.0039V14.0039C14 14.0139 14 14.0139 14 14.0239C14 15.1139 13.99 16.0039 12 16.0039C10.02 16.0039 10 15.1239 10 14.0339V13.0039C10 12.0039 10 12.0039 11 12.0039H13C14 12.0039 14 12.0039 14 13.0039Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.65 11.0039C19.34 12.6839 16.7 13.6839 14 14.0239",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62012 11.2734C4.87012 12.8134 7.41012 13.7434 10.0001 14.0334",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeBagIcon);
export default __webpack_public_path__ + "static/media/office-bag-icon.110a897b794fda2c18fdae01d8b8383e.svg";
export { ForwardRef as ReactComponent };